var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderClosed = function SvgFolderClosed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.655 12",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3581"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.274 1.574H7.92L6.65.069A.2.2 0 0 0 6.496 0H1.382A1.4 1.4 0 0 0 0 1.396v9.209a1.4 1.4 0 0 0 1.382 1.4h12.892a1.4 1.4 0 0 0 1.382-1.4V2.97a1.4 1.4 0 0 0-1.382-1.4Z",
    className: "folder-closed_svg__cls-1",
    "data-name": "Pfad 636"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderClosed);
export default ForwardRef;